// Saved per draft. Absence means the historical contract, never an implicit upgrade.
export const UPDATED_CONTRACT_TERMS = 'palm-beach-2026-10-26-v2';
export const FLAT_PAYMENT_POLICY_V3 = 'flat-first-payment-estimated-trips-30-60-v3';
export const updatedContractTerms = draft => draft?.contractTermsVersion === UPDATED_CONTRACT_TERMS;
export const completedTripFlatPolicy = policy => ['flat-retainer-estimated-trips-30-60-v2', FLAT_PAYMENT_POLICY_V3].includes(policy);
export const flatDepositIsFirstPayment = policy => policy === FLAT_PAYMENT_POLICY_V3;
